import React, { FC } from "react";
// libs
import NextImage from "next/image";
// components
import Link from "src/components/ui/Link";
import Button from "src/components/ui/button";
// const
import { EVariants } from "src/constants/variants";
import { REGISTER_YOUR_PET_BLOCK } from "src/constants/dynamic";
// hooks
import { useAppSelector } from "src/hooks";
// redux
import { dynamicStateFieldSelector } from "src/redux/slices";
// theme
import {
  ContentWrapper,
  TextAndButton,
  Title,
  Description,
  FirstImageContainer,
  SecondImageContainer,
  ButtonsWrapper,
  ButtonItem,
  Container,
  Illustration,
} from "./registerPet.styles";
// types
import { IDynamicRegisterYourPet } from "src/types/dynamic/home/registerYourPet";
import { amplitudeEvent, formatEventName } from "src/libs/amplitude";
import { useRouter } from "next/router";

const RegisterPet: FC = () => {
  const data = useAppSelector(
    dynamicStateFieldSelector<IDynamicRegisterYourPet>(REGISTER_YOUR_PET_BLOCK),
  );
  const { pathname } = useRouter();

  return (
    <ContentWrapper>
      <Container>
        <TextAndButton>
          <Title>{data?.title}</Title>
          <Description>{data?.text}</Description>
          <ButtonsWrapper>
            {(data?.buttons || []).map((button) => (
              <ButtonItem key={button.id}>
                {button.url.startsWith("http") ? (
                  <a href={button.url}>
                    <Button
                      variant={button.type.toUpperCase() as EVariants}
                      style={{ width: "100%" }}
                      onClick={() => {
                        amplitudeEvent(formatEventName(pathname, "bottom", button.title));
                      }}
                    >
                      {button.title}
                    </Button>
                  </a>
                ) : (
                  <Link href={button.url}>
                    <Button
                      variant={button.type.toUpperCase() as EVariants}
                      style={{ width: "100%" }}
                      onClick={() => {
                        amplitudeEvent(formatEventName(pathname, "bottom", button.title));
                      }}
                    >
                      {button.title}
                    </Button>
                  </Link>
                )}
              </ButtonItem>
            ))}
          </ButtonsWrapper>
        </TextAndButton>

        <FirstImageContainer>
          <NextImage src="/images/mobile-flat.png" width={300} height={500} layout={"responsive"} />
        </FirstImageContainer>
        <SecondImageContainer>
          <NextImage
            src="/images/mobile-flat-2.png"
            width={300}
            height={500}
            layout={"responsive"}
          />
        </SecondImageContainer>

        <Illustration>
          <NextImage src="/illustrations/Plants.svg" width={111} height={229} />
        </Illustration>
      </Container>
    </ContentWrapper>
  );
};

export default RegisterPet;
